import React from 'react';
import {
  Button,
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap';

export default function ColorNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  React.useEffect(() => {
    window.addEventListener("scroll", changeNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", changeNavbarColor);
    };
  }, []);
  const changeNavbarColor = () => {
    if (
      document.documentElement.scrollTop > 299 ||
      document.body.scrollTop > 299
    ) {
      setNavbarColor("bg-info");
    } else if (
      document.documentElement.scrollTop < 300 ||
      document.body.scrollTop < 300
    ) {
      setNavbarColor("navbar-transparent");
    }
  };
  return (
    <>
      <Navbar className={"fixed-top " + navbarColor} expand="lg">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand href="https://cloudengineer.global/">
              <img
                alt="cloud engineering logo"
                src={require("assets/img/cloud-engineer-logo.svg").default}
              />{" "}
              <span>Cloud Engineer •</span> Global
            </NavbarBrand>
            <button className="navbar-toggler" id="navigation">
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <UncontrolledCollapse navbar toggler="#navigation">
            <div className="navbar-collapse-header">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <a href="//cloudengineer.global/">
                    Cloud Engineer • <span>Global</span>
                  </a>
                </Col>
                <Col className="collapse-close text-right" xs="6">
                  <button className="navbar-toggler" id="navigation">
                    <i className="tim-icons icon-simple-remove" />
                  </button>
                </Col>
              </Row>
            </div>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="//cloudengineer.global/about/">
                  <i className="tim-icons icon-single-02" />
                  About Me
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="//cloudengineer.global/blog/">
                  <i className="tim-icons icon-paper" />
                  Blog
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="//cloudengineer.global/projects/">
                  <i className="tim-icons icon-app" />
                  Projects
                </NavLink>
              </NavItem>
              <NavItem>
                <Button
                  className="nav-link"
                  color="default"
                  href="//cloudengineer.global/"
                  size="sm"
                >
                  <p>
                    <i className="tim-icons icon-world" />
                    Home
                  </p>
                </Button>
              </NavItem>
            </Nav>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
    </>
  );
}
